import React from 'react';
import Layout from '../components/Layout';
import GlobalAuthorizationLayout from '../components/GlobalAuthorizationLayout';
import CreateTask from '../apps/CreateTask';
import CheckStaffUserLayout from '../layout/CheckStaffUserLayout';

const CreateTaskPage: React.FC = () => {
    return (
        <GlobalAuthorizationLayout>
            <CheckStaffUserLayout>
                <Layout>
                    <div>
                        <CreateTask/>
                    </div>
                </Layout>
            </CheckStaffUserLayout>
        </GlobalAuthorizationLayout>
    );
};

export default CreateTaskPage;
